import { NavLink } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleRight,
  faBars,
  faCaretDown,
  faMagnifyingGlass,
  faSquareXmark,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

import Logo from '../../assets/logoMercado.jpg'; // Adjust the path as necessary";
import { signout } from '../../redux/actions/userAction';

import './navBar.less';

// ✅ LA INTERFAZ VA AQUÍ (Fuera del componente)
interface RootState {
  cart: {
    cartItems: any[];
  };
  userSignin: {
    userInfo: {
      name?: string;
      isAdmin?: boolean;
      // puedes agregar más campos aquí
    } | null;
  };
}

export default function NavBar() {
  const dispatch = useDispatch<any>();

  const cart = useSelector((state: RootState) => state.cart || {});
  const { cartItems = [] } = cart;

  const userSignin = useSelector((state: RootState) => state.userSignin);
  const { userInfo } = userSignin;

  //const submenus = menuItems[0].submenu;

  const signoutHandler = (e: React.MouseEvent) => {
    // Evitamos que el enlace recargue la página si es un #
    if (e) e.preventDefault();
    dispatch(signout());
  };

  return (
    <nav>
      <img
        src={Logo} // Adjust the path as necessary
        alt="Logo Mercado"
        width="100"
        height="100"
        className="d-inline-block align-top"
      />
      <div className="enlace">
        {/*Inicio*/}
        <NavLink to="/" end className="enlace-base">
          Inicio
        </NavLink>
        {/*Productos*/}
        <div className="enlace-products">
          <div className="dropdown">
            <NavLink to="#" className="enlace-base">
              Productos <FontAwesomeIcon icon={faCaretDown} />
            </NavLink>
            <ul className="dropdown-content">
              {/* PLC  */}
              <li>
                <NavLink to="/productos/plc" >
                  PLC
                </NavLink>
              </li>
              {/* Tecnologia & Hogar*/}
              <li >
                <NavLink to="/productos/tecnologia-hogar" className="enlace-base" >
                  Tecnologia & Hogar
                </NavLink>

              </li>
            </ul>
          </div>
        </div>
        {/* Cart */}
        <NavLink to="/cart" className="enlace-base">
          Cart
          {cartItems.length > 0 && (
            <span className="badge">{cartItems.length}</span>
          )}
        </NavLink>
        {/* Signin */}

        {userInfo ? (
          <div className="enlace-signin">
            <div className="dropdown">
              <NavLink to="#" className="enlace-base">
                {userInfo.name} <FontAwesomeIcon icon={faCaretDown} />
              </NavLink>
              <ul className="dropdown-content">
                <li>
                  <NavLink to="/profile">User Profile</NavLink>
                </li>
                <li>
                  <NavLink to="/orderhistory">Order History</NavLink>
                </li>

                <li>
                  {' '}
                  <NavLink
                    to="#signout"
                    onClick={signoutHandler}
                    className="enlace-base"
                  >
                    Sign Out
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <NavLink to="/signin" className="enlace-base">
            Sign In
          </NavLink>
        )}

        {/* Admin */}
        {userInfo?.isAdmin && (
          <div className="enlace-admin">
            <div className="dropdown">
              <NavLink to="#" className="enlace-base">
                Admin <FontAwesomeIcon icon={faCaretDown} />
              </NavLink>
              <ul className="dropdown-content">
                <li>
                  <NavLink to="/productlist">Products</NavLink>
                </li>
                <li>
                  <NavLink to="/orderlist">Orders</NavLink>
                </li>
                <li>
                  <NavLink to="/userlist">Users</NavLink>
                </li>
              </ul>
            </div>
          </div>
        )}

        <NavLink to="contactarme" className="enlace-base">
          Contactarme
        </NavLink>
      </div>
    </nav>
  );
}
